import React from 'react';
import { ScheduleDayProps } from './ScheduleDisplay';
import { Flex, TextV2 } from '@withjoy/joykit';
import { BasicScheduleItem } from './BasicScheduleItem';
import { parseISO8601WithTimezone } from '@shared/components/ScheduleEditor/components/form/hooks/useGetEventTimezone';

export const BasicScheduleDay = (props: ScheduleDayProps) => {
  const { data } = props;

  const { items, dateISO8601TZ } = data;
  const date = parseISO8601WithTimezone(dateISO8601TZ).datetime;

  return (
    <Flex flexDirection="column">
      <TextV2
        borderBottom="1px solid"
        borderColor={'mono14'}
      >
        {date.toLocaleDateString()}
      </TextV2>
      <Flex
        flexDirection="column"
        gap="0.25rem"
      >
        {items.map(item => (
          <BasicScheduleItem
            key={item.id}
            data={item}
          />
        ))}
      </Flex>
    </Flex>
  );
};
